import Errors from "../components/ui/ErrorList";

export const errors = {
    components: { Errors },
    data() {
        return {
            errors: {},
        };
    },
    methods: {
        setErrors(errors) {
            if (errors) {
                this.errors = errors;
            } else {
                this.errors = {};
            }
        },
    },
};
